<template>
	<div
		id="actions-wrapper"
		:class="{'is-mobile': isMobileWebApp}"
	>
		<!-- tabs -->
		<ActionTabsBlock
			:media-container-height="mediaContainerHeight"
			:remember-scroll-position="isMobileWebApp"
		/>
	</div>
</template>

<script>
import ActionTabsBlock from '@videotools/js/blocks/ActionTabs';
import { mapGetters } from 'vuex';

export default {
	name:       'ActionsBlock',
	components: { ActionTabsBlock },
	props:      {
		mediaContainerHeight: {
			type:    Number,
			default: 0,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
};
</script>

<style lang="scss" scoped>
	#actions-wrapper {
		height: 100%;
		padding-left: 8px;
		padding-right: 8px;

		&:not(.is-mobile) {
			padding-left: 16px;
			padding-right: 16px;
		}
	}

	.is-mobile {
		#actions-wrapper {
			height: 100%
		}
	}
</style>
